(ns frontend.view.components.progress-indicator
  (:require
   [reagent.core :as r]
   [ui.util :as uu]
   [frontend.utils :as fu]
   [ui.components.button.view :as button]))

;;checks whether stage has lower (or equal) index in stages than current-stage.
;; current-stage and stage are given as keywords
(defn stage-active?
  [stages current-stage stage]
  (let [stage-kws (->> stages
                       (map :kw))
        index (fn [s]
                (count (take-while (partial not= s) stage-kws)))]
    (if (nil? current-stage)
      false
      (<= (index stage) (index current-stage)))))

(defn stage-element
  [{:keys [stage active? show-separator?]}]
  (let [{:keys [kw tooltip-text on-click!]} stage]
    [:span
     {:class "flex items-center flex-1 relative before:content-[''] before:block last:before:hidden before:h-px before:absolute before:left-8 before:right-1 before:top-1/2 before:bg-base-regular" }
     (when show-separator?
       [:span
        {:class "block h-px bg-base-regular"}])
     [:span
      {:class "*:py-0"
       :on-click   (when on-click!
                     on-click!)}
      [button/secondary-open 
       {:tooltip tooltip-text}
       (if active?
         [:i.fas.fa-check-circle]
         [:i.fal.fa-check-circle])]]]))

(defn view
  [{:keys [stages current-stage]}]
  (let [{:keys [kw]} (first stages)]
    [:div
     {:class "flex justify-evenly"}
     [stage-element
      {:stage           (first stages)
       :active?         (stage-active? stages current-stage kw)
       :show-separator? false}]
     (doall
      (for [stage (rest stages)
            :let [{:keys [kw]} stage]]
        ^{:key (str "progress-indicator-element-" kw)}
        [stage-element
         {:stage           stage
          :active?         (stage-active? stages current-stage kw)
          :show-separator? true}]))]))
